import React from "react";

import { COMPONENTS } from "../../../constants";
import { IBasicMedia, IBasicText, EventCallback } from "../../../interfaces";
import MediaImg from "../../media-img";
import CmsMarkdown from "../cms-markdown";

interface Props extends IBasicMedia {
  onLoad?: EventCallback;
}

class CmsMedia extends React.Component<Props> {
  basicText: IBasicText;
  constructor(props) {
    super(props);

    const { caption, align_text, id } = this.props;

    this.basicText = {
      text: caption,
      align_text,
      name: `cms-image-${id}`,
      id,
      __typename: COMPONENTS.MARKDOWN
    };

    this.handleOnLoad = this.handleOnLoad.bind(this);
  }

  handleOnLoad(event) {
    if (this.props.onLoad != null) {
      this.props.onLoad(event);
    }
  }

  render() {
    const { media } = this.props;
    return (
      <div className="cms-image">
        <MediaImg media={media} onLoad={this.handleOnLoad} />
        <CmsMarkdown content={this.basicText} />
      </div>
    );
  }
}

export default CmsMedia;
